export default {
  INTRO_ALT: 'Intro-Alt',
  RUBIK: 'Rubik',
  TRADE_GOTHIC: 'tgn-soft-round-comp',
} as const;
